import { Dropdown, DropdownItem, DropdownList, MenuToggle } from '@patternfly/react-core';
import { IAction } from '@patternfly/react-table';
import { EllipsisVIcon} from '@patternfly/react-icons'

import React, { useCallback, useState } from 'react';

/** Action item for {@link ItemActionsColumn}. Extends PatternFly's `IAction` with an optional icon. */
export type ActionItem = IAction & { icon?: React.ReactNode };

export const ItemActionsColumn = ({ items }: { items: ActionItem[] }) => {
    const [isOpen, setIsOpen] = useState(false);

    const onToggle = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    return (
        <Dropdown
            onSelect={() => setIsOpen(false)}
            isOpen={isOpen}
            toggle={(toggleRef) => <MenuToggle ref={toggleRef} onClick={onToggle} variant='plain'><EllipsisVIcon/></MenuToggle>}
            isPlain
            shouldFocusFirstItemOnOpen={false}
            popperProps={{ position: 'right' }}
            onOpenChange={() => setIsOpen(!isOpen)}
        >
            <DropdownList style={{ width:"max-content" }}>
            {items.map((item, index) => (
                    <DropdownItem
                        key={index}
                        component="button"
                        autoFocus={false}
                        onClick={(event) => item.onClick && item.onClick(event, index, {}, {})}
                        isDisabled={item.disabled}
                        icon={item.icon}
                    >
                        <div data-testid="item-actions-cell">{item.title}</div>
                    </DropdownItem>
            ))}
            </DropdownList>
        </Dropdown>
    );
};
